"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeriesName = exports.seriesName = void 0;
exports.seriesName = {
    SERIES_B: 'Serie B',
    SERIES_A: 'Serie A',
    SERIES_I: 'Serie I',
    SERIES_O: 'Serie O',
    NO_SERIES: '',
};
const getSeriesName = (key) => {
    if (key === undefined || key === null) {
        return '';
    }
    return exports.seriesName[key] || '';
};
exports.getSeriesName = getSeriesName;
//# sourceMappingURL=series.js.map